export const blockIconsNavigationExpandMore = (
	<span className='material-symbols-outlined'>expand_more</span>
);
